import React from 'react';
import CatalogCuisineCard from './CatalogCuisineCard';
import type { CatalogItem } from '../../services/restaurantService';
import './Catalog.css';

interface CatalogCuisineSliderProps {
  title?: string;
  items: CatalogItem[];
  onItemClick?: (item: CatalogItem) => void;
}

const CatalogCuisineSlider: React.FC<CatalogCuisineSliderProps> = ({
  title = 'Explore Cuisines',
  items,
  onItemClick,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <section className="catalog-cuisine-section" aria-label={title}>
      <div className="catalog-cuisine-header">
        <h2 className="catalog-cuisine-title">{title}</h2>
      </div>
      <div
        className={`catalog-cuisine-track${items.length === 1 ? ' catalog-cuisine-track--single' : ''}`}
        role="list"
      >
        {items.map((item) => (
          <div key={item.id} className="catalog-cuisine-item" role="listitem">
            <CatalogCuisineCard item={item} onClick={() => onItemClick?.(item)} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CatalogCuisineSlider;
